module.exports = __webpack_public_path__ + "media/images/minus-abc86cb1cb413956943e6633dba1a439.png";